import axios, {
  AxiosResponse,
} from "axios";
import getConfig from "../config/configUtil";

const conf = getConfig;

export interface DifferenceResult {
    original: number;
    afterTuning: number;
    difference: number;
}

export interface ChangesResult {
    name: string;
    power: DifferenceResult;
    torque: DifferenceResult;
}

export interface EngineResult {
  nameEngine: string;
  patches: string[];
  recordsTypes: ChangesResult[]
}

class RemappingService {
  async getSeries(): Promise<string[]> {
    try {
      const response: AxiosResponse = await axios.get(
        conf.BACKEND + "remapping/series"
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error("Failed to fetch series");
    }
  }

  async getGenerations(series: string): Promise<string[]> {
    try {
      const response: AxiosResponse = await axios.get(
        conf.BACKEND + "remapping/generation/" + series
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error("Failed to fetch generation");
    }
  }

  async getModels(series: string, generation: string): Promise<string[]> {
    try {
      const response: AxiosResponse = await axios.get(
        conf.BACKEND + "remapping/models/" + series + "/" + generation
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error("Failed to fetch models");
    }
  }

  async getEngines(series: string, generation: string, model: string): Promise<string[]> {
    try {
      const response: AxiosResponse = await axios.get(
        conf.BACKEND + "remapping/engines/" + series + "/" + generation + "/" + model
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error("Failed to fetch engines");
    }
  }  

  async getChanges(engine: string): Promise<EngineResult> {
    try {
      const response: AxiosResponse = await axios.get(
        conf.BACKEND + "remapping/changes/" + engine
      );
      return response.data;      
    } catch (error) {
      console.log(error);
      throw new Error("Failed to fetch changes");
    }
  }    
}

export default RemappingService;
